export default "__VITE_ASSET__c4ac8949__"